import { useTranslation } from 'react-i18next';
import { TextField, Box } from '@mui/material';

export default function LocationInput({ customLocation, setCustomLocation }) {
  const { t } = useTranslation(['form', 'validation']);
  const hasError = !customLocation.trim();

  return (
    <Box sx={{ my: 1.5 }}>
      <TextField
        id="customLocation"
        label={t('location.custom_location_label', { ns: 'form' })}
        placeholder={t('location.custom_location_placeholder', {
          ns: 'form',
        })}
        value={customLocation}
        onChange={(e) => setCustomLocation(e.target.value)}
        fullWidth
        variant="outlined"
        error={hasError}
        helperText={
          hasError
            ? t('location.exact_address_required', {
                ns: 'validation',
              })
            : ''
        }
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.23)',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(0, 0, 0, 0.6)',
          },
        }}
      />
    </Box>
  );
}
